import { render, staticRenderFns } from "./CustomerAddHeader.vue?vue&type=template&id=d7f281d6&scoped=true"
import script from "./CustomerAddHeader.vue?vue&type=script&lang=js"
export * from "./CustomerAddHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f281d6",
  null
  
)

export default component.exports